import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, BaseModelObject, ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"

// Model Objects

export class AuthenticationService extends ServiceBase {

  public async logOutOfSession(tenantGroupId: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<void> {
    const req = {
    tenantGroupId:tenantGroupId.toString(),
    };
    const extractor = null;
    return this.makeJsonRequest("authentication/v1/logOutOfSession", req, false, extractor, opts);
  };
}

export const authenticationService = new AuthenticationService();